<template>
  <div v-if="showPage" class="home-page">
    <!-- 轮播图区域 -->
    <section class="banner-section">
      <el-carousel class="banner-carousel hidden-xs-only" trigger="click" height="clamp(400px, 50vw, 900px)"
        :autoplay="true">
        <el-carousel-item v-for="(item, index) in bannerList" :key="index">
          <img class="banner-img" :src="getBannerImage(item)" alt="banner">
        </el-carousel-item>
      </el-carousel>

      <!-- 移动端轮播图 -->
      <el-carousel class="banner-carousel hidden-sm-and-up" trigger="click" height="280px" :autoplay="true">
        <el-carousel-item v-for="(item, index) in bannerList" :key="index">
          <img class="banner-img" :src="getBannerImage(item)" alt="banner">
        </el-carousel-item>
      </el-carousel>
    </section>

    <!-- 关于我们区域 -->
    <section class="about-section animate-section" ref="aboutSection">
      <div class="container">
        <div class="about-content">
          <div class="about-text animate-left">
            <h2 class="section-title">关于仓谷数字</h2>
            <!-- <p class="about-subtitle">是一家以"万物互联、智化天下"为宗旨，致力于提供数字化综合服务。</p> -->
            <div class="about-desc">
              <p>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;浙江仓谷数字技术股份有限公司深耕数字化领域十余载，以技术研发、行业应用、平台赋能、智慧系统设计为核心，坚持多元化、数字化、战略导向型发展，凭借深厚技术积淀，全面支撑旗下平台与智慧化系统高效运营。
                公司聚焦智慧系统与智慧电厂两大产业方向，融合 AI视觉算法、边缘计算、物联网、大数据、云计算等前沿技术，打造跨场景智能解决方案。智慧系统覆盖校园、医院、社区、商场等行业场景，实现风险精准识别与实时告警；面向施工全流程，提供安全监控、质量检测、材料与进度一体化管理，显著降本增效。
                面向电力行业，公司打造智慧电厂整体解决方案，构建智慧安全、设备、运行、燃料、经营、综合、中心七大模块，覆盖生产、运维、经营全场景，以智能感知、大数据诊断、设备预警助力电厂安全高效、绿色低碳运行。
                企业坚守匠心精神，以数字技术赋能多行业转型升级，助力数字经济高质量发展。</p>
            </div>
            <button class="btn-primary" @click="toPage('/about')">了解我们</button>
          </div>
          <div class="about-image animate-right">
            <img src="../assets/Home/images/home/aboutImg.png" alt="关于仓谷数字">
          </div>
        </div>
      </div>
    </section>

    <!-- 业务领域区域 -->
    <section class="business-section animate-section" ref="businessSection">
      <div class="container">
        <div class="section-header">
          <h2 class="section-title">不同领域下的仓谷</h2>
          <img class="divider" src="../assets/img/spliceImg.png" alt="divider">
        </div>
        <div class="business-grid">
          <div class="business-card animate-up" v-for="(item, index) in businessList" :key="index"
            :style="{ animationDelay: `${index * 0.15}s` }">
            <div class="card-overlay">
              <h3 class="card-title">{{ item.title }}</h3>
              <p class="card-desc">{{ item.desc }}</p>
            </div>
            <img :src="item.image" :alt="item.title">
          </div>
        </div>
      </div>
    </section>

    <!-- 视频优势区域 -->
    <section class="advantage-section animate-section" ref="videoSection">
      <div class="container">
        <div class="advantage-content">
          <div class="advantage-list animate-right">
            <div class="advantage-item" v-for="(item, index) in advantageList" :key="index">
              <img class="advantage-icon" :src="item.icon" :alt="item.title">
              <div class="advantage-info">
                <h3 class="advantage-title">{{ item.title }}</h3>
                <p class="advantage-desc">{{ item.desc }}</p>
              </div>
            </div>
          </div>
          <div class="video-box animate-left">
            <div class="video-mask" v-show="!videoIsPlay" @click="playVideo">
              <div class="video-mask-content">
                <h3 class="video-title">观看智慧仓谷视频</h3>
                <img class="play-icon" src="../assets/icon/videoPlay.png" alt="播放">
              </div>
            </div>
            <video ref="videoRef" @click="pauseVideo" class="video-player" type="video/mp4"
              src="https://ziyuan.rongzw.com/video/cangdt.mp4"></video>
          </div>
        </div>
      </div>
    </section>

    <!-- 发展历程区域 -->
    <section class="history-section">
      <div class="container">
        <div class="section-header">
          <h2 class="section-title">发展历程</h2>
          <img class="divider" src="../assets/img/spliceImg.png" alt="divider">
        </div>
        <div class="history-slider" @mouseenter="pauseAutoScroll" @mouseleave="resumeAutoScroll">
          <button class="slider-btn prev" @click="prevSlide">
            <img src="../assets/img/wLeftIcon.png" alt="上一页">
          </button>
          <div class="slider-viewport">
            <div class="slider-track" :style="{ transform: `translateX(-${slideIndex * slideWidth}px)` }">
              <div class="history-card" v-for="(item, index) in historyList" :key="index">
                <img :src="item.picturePath" class="card-image" :alt="item.title">
                <div class="card-content">
                  <div class="year-tag">
                    <img :src="activeIndex === index ? dateIconActive : dateIcon" alt="date">
                    <span>{{ item.year }}</span>
                  </div>
                  <p class="card-title">{{ item.title }}</p>
                </div>
              </div>
            </div>
          </div>
          <button class="slider-btn next" @click="nextSlide">
            <img src="../assets/img/wRightIcon.png" alt="下一页">
          </button>
        </div>

        <!-- 时间轴 -->
        <div class="timeline">
          <div class="timeline-track">
            <button class="timeline-nav prev" @click="prevSlide">
              <img src="../assets/img/icon/temelineLeft.png" alt="上一页">
            </button>
            <div class="timeline-line">
              <div class="timeline-progress" :style="{ width: `${(activeIndex / (historyList.length - 1)) * 100}%` }">
              </div>
            </div>
            <button class="timeline-nav next" @click="nextSlide">
              <img src="../assets/img/icon/timelineRight.png" alt="下一页">
            </button>
          </div>
          <div class="timeline-points">
            <div v-for="(item, index) in historyList" :key="index" class="timeline-point"
              :class="{ active: activeIndex === index }" @click="goToSlide(index)">
              <span class="point-year">{{ item.year }}</span>
              <span class="point-dot"></span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 人物介绍横幅 -->
    <section class="character-banner">
      <img src="../assets/img/characterIntroduction.png" alt="人物介绍">
    </section>

    <!-- 愿景区域 -->
    <section class="vision-section">
      <div class="container">
        <div class="vision-content">
          <div class="section-header light">
            <h2 class="section-title">愿景与定位</h2>
            <img class="divider" src="../assets/img/spliceImg.png" alt="divider">
          </div>
          <p class="vision-text">"深耕算法研究，打造技术硬实力" 为核心定位，将算法研发作为发展的根本驱动力。</p>
          <p class="vision-text">以精准、高效的算法解决方案，破解行业痛点。愿景是成为算法领域的创新引领者，凭借扎实的算法研究功底，为产业智能化升级提供核心支撑，用技术实力赋能发展、创造价值。</p>
          <button class="btn-light" @click="toPage('/Joinus')">加入我们</button>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, nextTick, computed } from 'vue'
import { useRouter } from 'vue-router'
import apiService from '@/api/index'

const router = useRouter()
const showPage = ref(false)
const videoIsPlay = ref(false)
const videoRef = ref(null)
const activeIndex = ref(0)
const slideIndex = ref(0)
const autoScrollTimer = ref(null)
const isAutoScrollPaused = ref(false)

// 动画相关 refs
const aboutSection = ref(null)
const businessSection = ref(null)
const videoSection = ref(null)

// 图标路径
const dateIcon = require('../assets/img/icon/dateIcon.png')
const dateIconActive = require('../assets/img/icon/dateIconCur.png')

// 轮播图数据
const bannerList = ref(['2.png'])

// 业务领域数据
const businessList = ref([
  {
    title: '智慧算法',
    desc: '自主算法，赋能电力、监理、管家等垂直场景，打造技术核心壁垒',
    image: require('../assets/Home/images/home/good/1.png')
  },
  {
    title: '软硬融合',
    desc: '软硬一体化创新，覆盖医疗、交易等多领域，实现产品与服务的深度融合',
    image: require('../assets/Home/images/home/good/2.png')
  },
  {
    title: '安全应用',
    desc: '全场景安防解决方案，守护社区、家庭、校园等每一处安全',
    image: require('../assets/Home/images/home/good/3.png')
  },
  {
    title: '在线交易',
    desc: '一站式在线交易服务平台，打通技术、产品、交易全链路闭环',
    image: require('../assets/Home/images/home/good/4.png')
  }
])

// 优势数据
const advantageList = ref([
  {
    icon: require('../assets/icon/videoIcon1.png'),
    title: '核心引擎',
    desc: '以"智算中心-AI算法-智慧系统"为核心，单卡性能利用率提升至70%+，集群运行效率超行业平均水平'
  },
  {
    icon: require('../assets/icon/videoIcon2.png'),
    title: '硬软融合',
    desc: '自主研发智能硬件（机器狗、激光雷达、算法摄像头）+ 全栈算法体系（多模态识别、动态优化模型）'
  },
  {
    icon: require('../assets/icon/videoIcon3.png'),
    title: '全链自主',
    desc: '9项实用新型专利、19项商标权、15个软件著作权，构建国产技术安可替代体系'
  }
])

// 发展历程数据
const historyList = ref([
  {
    picturePath: 'https://www.cangdt.com/img/developmentImg/1.png',
    year: 2011,
    title: '成立太仓信拓物流有限公司，布局物流供应链'
  },
  {
    picturePath: 'https://www.cangdt.com/img/developmentImg/2.png',
    year: 2015,
    title: '信拓物流正式登陆新三板'
  },
  {
    picturePath: 'https://www.cangdt.com/img/developmentImg/3.png',
    year: 2021,
    title: '荣创企业收购信拓物流'
  },
  {
    picturePath: 'https://www.cangdt.com/img/developmentImg/4.png',
    year: 2022,
    title: '完成并购，更名"仓谷数字"'
  },
  {
    picturePath: 'https://www.cangdt.com/img/developmentImg/5.png',
    year: 2023,
    title: '收购荣装网，部署数字化家装监理；迁入浙江丽水莲都区，成为区域数字化上市企业先行者'
  },
  {
    picturePath: 'https://www.cangdt.com/img/developmentImg/6.png',
    year: 2024,
    title: '数字化监理系统研发成功并完成生产前准备'
  },
  {
    picturePath: 'https://www.cangdt.com/img/developmentImg/7.png',
    year: 2025,
    title: '成立中科院自动化所仓谷算法研究所智算中心；研发算力系统'
  }
])

// 计算属性
const slideWidth = computed(() => {
  if (window.innerWidth < 768) {
    return window.innerWidth - 40
  } else if (window.innerWidth < 1024) {
    return 320
  }
  return 380
})

// 方法
const getBannerImage = (name) => {
  return `https://cangdt.com/img/banner/${name}`
}

const toPage = (path) => {
  if (path.startsWith('http')) {
    window.open(path, '_blank')
  } else {
    router.push(path)
  }
}

const playVideo = () => {
  if (videoRef.value) {
    videoRef.value.play()
    videoIsPlay.value = true
  }
}

const pauseVideo = () => {
  if (videoRef.value) {
    videoRef.value.pause()
    videoIsPlay.value = false
  }
}

const prevSlide = () => {
  if (activeIndex.value > 0) {
    activeIndex.value--
    slideIndex.value = activeIndex.value
  }
}

const nextSlide = () => {
  if (activeIndex.value < historyList.value.length - 1) {
    activeIndex.value++
  } else {
    activeIndex.value = 0
  }

  const maxVisible = window.innerWidth < 768 ? 1 : 3
  if (slideIndex.value < historyList.value.length - maxVisible) {
    slideIndex.value = activeIndex.value
  } else {
    slideIndex.value = 0
  }
}

const goToSlide = (index) => {
  activeIndex.value = index
  const maxVisible = window.innerWidth < 768 ? 1 : 3
  slideIndex.value = Math.min(index, historyList.value.length - maxVisible)
}

const startAutoScroll = () => {
  if (autoScrollTimer.value) {
    clearInterval(autoScrollTimer.value)
  }
  autoScrollTimer.value = setInterval(() => {
    if (!isAutoScrollPaused.value) {
      nextSlide()
    }
  }, 4000)
}

const pauseAutoScroll = () => {
  isAutoScrollPaused.value = true
}

const resumeAutoScroll = () => {
  isAutoScrollPaused.value = false
}

// 滚动动画
const handleScroll = () => {
  const sections = [
    { el: aboutSection.value, class: 'animated' },
    { el: businessSection.value, class: 'animated' },
    { el: videoSection.value, class: 'animated' }
  ]

  sections.forEach(({ el, class: className }) => {
    if (!el) return
    const rect = el.getBoundingClientRect()
    const windowHeight = window.innerHeight

    if (rect.top < windowHeight * 0.8 && rect.bottom > 0) {
      el.classList.add(className)
    }
  })
}

// 生命周期
onMounted(() => {
  showPage.value = true
  startAutoScroll()

  nextTick(() => {
    window.addEventListener('scroll', handleScroll)
    handleScroll()
  })
})

onUnmounted(() => {
  if (autoScrollTimer.value) {
    clearInterval(autoScrollTimer.value)
  }
  window.removeEventListener('scroll', handleScroll)
})
</script>

<style scoped lang="scss">
// 变量定义
:root {
  --primary-color: #4F46E5;
  --primary-dark: #4338ca;
  --text-dark: #36383D;
  --text-gray: #6F6F6F;
  --bg-light: #F4F4F9;
  --bg-dark: #161817;
  --white: #ffffff;
  --transition: all 0.3s ease;
}

// 基础样式
.home-page {
  background: var(--white);
  overflow-x: hidden;
}

.container {
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 20px;
}

// 通用标题样式
.section-header {
  text-align: center;
  margin-bottom: 40px;

  &.light {
    .section-title {
      color: #ffffff;
    }
  }
}

.section-title {
  font-size: clamp(24px, 4vw, 36px);
  font-weight: 600;
  color: var(--text-dark);
  margin-bottom: 16px;
}

.divider {
  height: 7px;
  width: auto;
}

// 按钮样式
.btn-primary {
  display: inline-block;
  background: #4F46E5;
  color: #ffffff;
  padding: 12px 32px;
  font-size: 16px;
  font-weight: 500;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: var(--transition);

  &:hover {
    background: var(--primary-dark);
    transform: translateY(-2px);
  }
}

.btn-light {
  display: inline-block;
  background: #ffffff;
  color: #4F46E5;
  padding: 12px 32px;
  font-size: 16px;
  font-weight: bolder;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: var(--transition);
  margin-top: 24px;

  &:hover {
    background: var(--bg-light);
    transform: translateY(-2px);
  }
}

// 动画样式
.animate-section {
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 0.6s ease, transform 0.6s ease;

  &.animated {
    opacity: 1;
    transform: translateY(0);

    .animate-left {
      opacity: 1;
      transform: translateX(0);
    }

    .animate-right {
      opacity: 1;
      transform: translateX(0);
    }

    .animate-up {
      opacity: 1;
      transform: translateY(0);
    }
  }
}

.animate-left {
  opacity: 0;
  transform: translateX(-50px);
  transition: opacity 0.8s ease 0.2s, transform 0.8s ease 0.2s;
}

.animate-right {
  opacity: 0;
  transform: translateX(50px);
  transition: opacity 0.8s ease 0.2s, transform 0.8s ease 0.2s;
}

.animate-up {
  opacity: 0;
  transform: translateY(50px);
  transition: opacity 0.8s ease, transform 0.8s ease;
}

// 轮播图区域
.banner-section {
  width: 100%;
}

.banner-carousel {
  width: 100%;
}

.banner-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

// 关于我们区域
.about-section {
  padding: 80px 0;
  background: var(--white);
}

.about-content {
  display: flex;
  align-items: center;
  gap: 60px;
}

.about-text {
  flex: 0 0 40%;

  .about-subtitle {
    font-size: clamp(18px, 2.5vw, 26px);
    color: var(--text-dark);
    margin: 20px 0;
    line-height: 1.5;
  }

  .about-desc {
    p {
      font-size: 16px;
      color: var(--text-gray);
      line-height: 1.8;
      margin-bottom: 16px;
    }
  }
}

.about-image {
  flex: 1;

  img {
    width: 100%;
    height: auto;
    border-radius: 8px;
  }
}

// 业务领域区域
.business-section {
  padding: 80px 0;
  background: var(--bg-light);
}

.business-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}

.business-card {
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  cursor: pointer;
  aspect-ratio: 3/4;
  transition: var(--transition);

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);

    .card-overlay {
      background: linear-gradient(to bottom, rgba(79, 70, 229, 0.9) 0%, rgba(79, 70, 229, 0.4) 100%);
    }
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .card-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.2) 50%, rgba(0, 0, 0, 0) 100%);
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding: 40px 20px;
    text-align: center;
    transition: var(--transition);
  }

  .card-title {
    font-size: 24px;
    font-weight: 600;
    color: #ffffff;
    margin-bottom: 16px;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  }

  .card-desc {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.95);
    line-height: 1.6;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  }
}

// 优势视频区域
.advantage-section {
  background: rgb(79, 70, 229);
  color: #ffffff;
  padding: 60px 0;
  margin: 60px 0 60px 0;
}

.advantage-content {
  display: flex;
  gap: 40px;
}

.advantage-list {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 40px;
}

.advantage-item {
  display: flex;
  align-items: flex-start;
  gap: 24px;
  color: var(--white);

  .advantage-icon {
    width: 80px;
    height: 80px;
    flex-shrink: 0;
  }

  .advantage-title {
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 8px;
  }

  .advantage-desc {
    font-size: 15px;
    line-height: 1.6;
    opacity: 0.95;
  }
}

.video-box {
  flex: 1;
  position: relative;
  overflow: hidden;
  min-height: 400px;
}

.video-player {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.video-mask {
  position: absolute;
  inset: 0;
  background: rgba(79, 70, 229, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 2;
  transition: var(--transition);

  &:hover {
    background: rgba(79, 70, 229, 0.5);
  }
}

.video-mask-content {
  text-align: center;
  color: var(--white);

  .video-intro {
    font-size: 18px;
    margin-bottom: 12px;
    opacity: 0.9;
  }

  .video-title {
    font-size: 28px;
    font-weight: 600;
    margin-bottom: 20px;
  }

  .play-icon {
    width: 70px;
    height: 70px;
    transition: var(--transition);

    &:hover {
      transform: scale(1.1);
    }
  }
}

// 发展历程区域
.history-section {
  padding: 80px 0;
  background: radial-gradient(50% 50% at 70% 41%, rgba(77, 67, 92, 0.04) 0%, rgba(77, 67, 92, 0.04) 15%, rgba(77, 67, 92, 0) 15%);
}

.history-slider {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 40px;
}

.slider-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  transition: var(--transition);
  flex-shrink: 0;

  &:hover {
    transform: scale(1.1);
  }

  img {
    width: 40px;
    height: 40px;
  }
}

.slider-viewport {
  flex: 1;
  overflow: hidden;
  border-radius: 8px;
}

.slider-track {
  display: flex;
  gap: 57px;
  transition: transform 0.4s ease;
}

.history-card {
  flex: 0 0 346px;
  background: #F8F8F8;
  border-radius: 8px;
  overflow: hidden;
  transition: var(--transition);

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  }

  .card-image {
    width: 100%;
    height: 255px;
    object-fit: cover;
  }

  .card-content {
    padding: 16px;
    background: aliceblue;
    height: 100px;
  }

  .year-tag {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #9E9E9E;
    font-size: 14px;
    margin-bottom: 8px;

    img {
      width: 20px;
      height: 20px;
    }
  }

  .card-title {
    font-size: 14px;
    color: var(--text-dark);
    line-height: 1.5;
  }
}

// 时间轴
.timeline {
  padding: 0 60px;
}

.timeline-track {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
}

.timeline-nav {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  flex-shrink: 0;

  img {
    width: 24px;
    height: 24px;
  }
}

.timeline-line {
  flex: 1;
  height: 3px;
  background: #E5E5E5;
  border-radius: 2px;
  position: relative;
  overflow: hidden;
}

.timeline-progress {
  height: 100%;
  background: var(--primary-color);
  transition: width 0.4s ease;
}

.timeline-points {
  display: flex;
  justify-content: space-between;
  padding: 0 28px;
}

.timeline-point {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: var(--transition);

  &:hover {
    .point-year {
      color: var(--primary-color);
    }
  }

  &.active {
    .point-year {
      color: var(--primary-color);
      font-weight: 600;
    }

    .point-dot {
      background: var(--white);
      border-color: var(--primary-color);
      transform: scale(1.2);
    }
  }

  .point-year {
    font-size: 14px;
    color: var(--text-gray);
    margin-bottom: 8px;
    transition: var(--transition);
  }

  .point-dot {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: #E5E5E5;
    border: 2px solid transparent;
    transition: var(--transition);
  }
}

// 人物横幅
.character-banner {
  width: 100%;

  img {
    width: 100%;
    height: auto;
    display: block;
  }
}

// 愿景区域
.vision-section {
  background-color: #161817;
  padding: 80px 0;

  .vision-content {
    text-align: center;
    max-width: 800px;
    margin: 0 auto;
  }

  .vision-text {
    color: rgba(255, 255, 255, 0.85);
    font-size: 16px;
    line-height: 1.8;
    margin-bottom: 16px;
  }
}

// 响应式布局 - 平板设备 (max-width: 1024px)
@media screen and (max-width: 1024px) {
  .container {
    padding: 0 24px;
  }

  .about-content {
    flex-direction: column;
    gap: 40px;
  }

  .about-text {
    flex: none;
    width: 100%;
    text-align: center;
  }

  .about-image {
    width: 80%;
  }

  .business-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .advantage-content {
    flex-direction: column;
  }

  .video-box {
    min-height: 350px;
  }

  .history-card {
    flex: 0 0 300px;
  }
}

// 响应式布局 - 移动设备 (max-width: 768px)
@media screen and (max-width: 768px) {
  .container {
    padding: 0 16px;
  }

  .about-section,
  .business-section,
  .history-section,
  .vision-section {
    padding: 50px 0;
  }

  .about-image {
    width: 100%;
  }

  .business-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .business-card {
    aspect-ratio: 16/9;

    .card-overlay {
      padding: 24px;
      justify-content: center;
    }

    .card-title {
      font-size: 20px;
      margin-bottom: 8px;
    }

    .card-desc {
      font-size: 13px;
    }
  }

  .advantage-item {
    flex-direction: column;
    text-align: center;
    gap: 16px;

    .advantage-icon {
      width: 60px;
      height: 60px;
      margin: 0 auto;
    }

    .advantage-title {
      font-size: 20px;
    }

    .advantage-desc {
      font-size: 14px;
    }
  }

  .video-box {
    min-height: 220px;
  }

  .video-mask-content {
    .video-title {
      font-size: 20px;
    }

    .video-intro {
      font-size: 14px;
    }

    .play-icon {
      width: 50px;
      height: 50px;
    }
  }

  .history-slider {
    .slider-btn {
      display: none;
    }
  }

  .slider-viewport {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .slider-track {
    transition: none;
  }

  .history-card {
    flex: 0 0 280px;
  }

  .timeline {
    display: none;
  }

  .vision-section {
    .vision-text {
      font-size: 14px;
      padding: 0 10px;
    }
  }
}

// 响应式布局 - 大屏设备 (min-width: 1440px)
@media screen and (min-width: 1440px) {
  .container {
    max-width: 1400px;
  }

  .about-text {
    flex: 0 0 35%;
  }

  .advantage-item {
    .advantage-icon {
      width: 90px;
      height: 90px;
    }

    .advantage-title {
      font-size: 28px;
    }

    .advantage-desc {
      font-size: 16px;
    }
  }
}

// 隐藏类
.hidden-xs-only {
  @media screen and (max-width: 768px) {
    display: none !important;
  }
}

.hidden-sm-and-up {
  @media screen and (min-width: 769px) {
    display: none !important;
  }
}
</style>
